// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__2Pf8z","tooltipArrow":"Tooltip_tooltipArrow__Jsvi8","tooltipClose":"Tooltip_tooltipClose__CAOse"};